import { render, staticRenderFns } from "./ChangeStatusModal.vue?vue&type=template&id=1b353540&scoped=true&"
import script from "./ChangeStatusModal.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusModal.vue?vue&type=style&index=0&id=1b353540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b353540",
  null
  
)

export default component.exports